module.exports = __webpack_public_path__ + "static/media/linkedIn-icon.3b3acd16.png";